<template>
	<div
		class="ry-form__fill-page"
		v-enterToNext="true"
	>
		<div
			v-if="formSet.isInit && hasHeader && formSet.customFormStyle.headerType === FORM_THEME_TYPE_COLOR"
			:style="{backgroundColor: formSet.customFormStyle.headerColor}"
			class="header-color"
		>
		</div>
		<div
			v-if="formSet.isInit && formSet.formDes"
			class="form-des-container"
		>
			<h3 v-if="false">
				{{formSet.formName}}
			</h3>
			<div v-html="formSet.formDes">
			</div>
		</div>

		<template v-if="!formSet.showMultiTab || formSet.showMultiTab === 'NO' || formSet.mobileShowTab === 'NO'">
			<Sectional
				v-for="(item, idx) in formSet.children"
				v-if="item.permission !== PERMISSION__HIDDEN && !item.hiddenStatus"
				:key="item.dataId"
				:index="idx"
				:length="formSet.children.length"
				:type="formSet.status"
				:value="item"
			>
			</Sectional>
		</template>

		<template v-else>

			<template v-if="formSet.firstAsTab === 'NO'">
				<Sectional
					class="first-sectional"
					v-if="formSet.children[0] && formSet.children[0].permission !== PERMISSION__HIDDEN && !formSet.children[0].hiddenStatus"
					:index="0"
					:length="formSet.children.length"
					:type="formSet.status"
					:value="formSet.children[0]"
				>
				</Sectional>
			</template>

			<el-tabs
				v-if="!tabsHidden && tabsList && tabsList.length"
				id="formTabs"
				class="form-fill-page-tabs"
				:class="{'has-first-tabs' : formSet.firstAsTab === 'YES'}"
				:value="activeName"
				type="card"
				@tab-click="handleClick"
			>
				<el-tab-pane
					v-for="(item, idx) in tabsList"
					:key="item.dataId"
					v-if="item.permission !== PERMISSION__HIDDEN && !item.hiddenStatus"
					:label="item.sectionName || '标签'"
					:name="item.dataId"
				>
					<Sectional
						:index="idx"
						:length="formSet.children.length"
						:type="formSet.status"
						:value="item"
					>
					</Sectional>
				</el-tab-pane>
			</el-tabs>
		</template>
	</div>
</template>

<script>
	import {
		PERMISSION__HIDDEN,
		FORM_THEME_TYPE_COLOR
	} from '../types'

	export default {
		props: {
			formSet: Object,
			hasHeader: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				FORM_THEME_TYPE_COLOR,
				PERMISSION__HIDDEN
			}
		},
		computed: {

			tabsList() {
				if (this.formSet.firstAsTab === 'NO') {
					return this.formSet.children.slice(1)
				} else {
					return this.formSet.children
				}
			},
			tabsHidden() {
				let hidden = true
				this.tabsList.forEach(item => {
					if (item.permission !== PERMISSION__HIDDEN && !item.hiddenStatus) {
						hidden = false
					}
				})
				return hidden
			},
			activeName() {
				let name = ''
				for (let i = 0; i < this.tabsList.length; i++) {
					const item = this.tabsList[i]
					if (item.permission !== PERMISSION__HIDDEN && !item.hiddenStatus) {
						name = item.dataId
						break
					}
				}
				return name
			}
		},
		methods: {
			handleClick(tab, event) {}
		}
	}
</script>
<style lang="less">
	.ry-form__fill-page {
		.header-color {
			height: 10px;
			width: 100%;
		}

		.form-des-container {
			background-color: #fff;
			padding: 10px;

			>h3 {
				font-size: 24px;
				line-height: 1.5;
				margin: 0;

				i {
					font-size: 16px;
				}
			}

			img {
				max-width: 100%;
			}
		}

		.first-sectional {
			margin-bottom: 0 !important;
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}

		.form-fill-page-tabs {
			border-radius: 10px;
			padding-top: 10px;
			/*margin-top: 20px;*/
			background-color: #ffffff;

			.el-tabs__header {
				padding-left: 10px;
				padding-right: 10px;
				border-color: #D9D9D9;

				.el-tabs__nav {
					border-top: none;
					border-right: none;

					.el-tabs__item {
						margin-right: 10px;
						border-right: 1px solid #D9D9D9;
						border-top: 1px solid #D9D9D9;
						border-bottom: 1px solid #D9D9D9;
						border-top-left-radius: 4px;
						border-top-right-radius: 4px;
						background-color: #f4f6f9;
						padding: 0 16px;
						height: 36px;
						line-height: 36px;
						font-size: 14px;
						color: #333333;

						&.is-active {
							background-color: #ffffff;
							border-bottom: 1px solid #ffffff;
							color: #4A66FA;
						}

					}
				}

				.el-icon-arrow-left,
				.el-icon-arrow-right {
					background: #9e9e9e;
					color: #ffffff;
					font-size: 16px;
					border-radius: 50%;
				}
			}

			.el-tabs__content {

				.ry-form__section {
					margin-top: 0;
				}
			}
		}

		.has-first-tabs {
			margin-top: 0;
			border-top-left-radius: 0;
			border-top-right-radius: 0;
		}

		.tab-fixed {
			position: fixed;
		}
	}
</style>
